export const THEME_KEY = "type-ebx-theme";

export const WORD_API_URL = 'https://random-words-api.kushcreates.com/api?language=en';
export const ESSAY_API_URL = 'https://baconipsum.com/api/?type=meat-and-filler&paras=1&format=text';
export const STORAGE_KEYS = {
    LEADERBOARD_EASY: 'ebxtype_leaderboard_easy',
    LEADERBOARD_MEDIUM: 'ebxtype_leaderboard_medium',
    LEADERBOARD_HARD: 'ebxtype_leaderboard_hard',
    STATS: 'ebxtype_stats'
};